import Service from './Service';

export default class ServiceProducer extends Service {
	public fetch() {
		return this.wrapper.get(`report/producers`);
	}
}
